import(/* webpackMode: "eager", webpackExports: ["AIVoiceoverWrapper"] */ "/app/apps/sb-shell/app/(darkHeader)/ai/voiceover/_components/AiVoiceoverWrapper.tsx");
